<template>
    <div class="bom-main-content">
    <div class="bom-table-area">
    <!-- BOM Table -->
     <div class="bom-filter-row">
      <input
        v-model="filterName"
        placeholder="Filter by Name"
        class="bom-filter-input"
        type="text"
      />
      <input
        v-model="filterPartNo"
        placeholder="Part No."
        class="bom-filter-input"
        type="text"
      />
      <select v-model="filterGroupName" class="bom-filter-select">
        <option value="">Group Name</option>
        <option v-for="name in groupNameOptions" :key="name" :value="name">{{ name }}</option>
      </select>
      <select v-model="filterPurchaseTag" class="bom-filter-select">
        <option value="">Purchase Tag</option>
        <option v-for="tag in purchaseTagOptions" :key="tag" :value="tag">{{ tag }}</option>
      </select>
      <input
        v-model="filterReorderLevel"
        placeholder="Reorder Level"
        class="bom-filter-input"
        type="number"
        min="0"
        style="width:110px"
      />
      <input
        v-model="filterComponentName"
        placeholder="Filter by BOM Component"
        class="bom-filter-input"
        type="text"
      />
      <button type="button" class="clear-filters-btn" @click="clearFilters">
        Clear Filters
      </button>
      <button type="button" @click="openAddModal" style="margin-left: 8px;">
        Add Item
      </button>
    </div>
    <div class="table-scroll">
    <table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Part No.</th>
          <th>Description</th>
          <th>Is Batch Wise</th>
          <th>Group Name</th>
          <th>Units</th>
          <th>Reorder Level</th>
          <th>Purchase Tag</th>
          <!-- <th>Name of BOM</th>
          <th>Unit of manufacture</th> -->
          <th style="width: 400px; max-width: 400px;">Components</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in filteredBomList" :key="item.name">
          <td>{{ item.Name }}</td>
          <td>{{ item['Part No.'] }}</td>
          <td>{{ item.Description }}</td>
          <td>{{ item['Is Batch Wise'] }}</td>
          <td>{{ item['Group Name'] }}</td>
          <td>{{ item.Units }}</td>
          <td>{{ item['Reorder Level'] }}</td>
          <td>{{ item['Purchase Tag'] }}</td>
          <!-- <td>{{ item['Name of BOM'] }}</td>
          <td>{{ item['Unit of manufacture'] }}</td> -->
          <td style="width: 400px; max-width: 400px; overflow-x: auto;">
            <table class="mini-components-table">
              <thead>
                <tr>
                  <th>Item Name</th>
                  <th>Qty</th>
                  <th>Godown</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(comp, cidx) in item.Components" :key="cidx">
                  <td>{{ comp['Item Name'] }}</td>
                  <td>{{ comp['Quantity'] }}</td>
                  <td>{{ comp['Godown'] }}</td>
                </tr>
              </tbody>
            </table>
          </td>
          <td>
            <button @click="openEditModal(item)">Edit</button>
            <button @click="openDeleteModal(item.Name)">Delete</button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
    </div>
    </div>
    <div v-if="showDeleteModal" class="modal-overlay"><!-- Delete Modal -->
      <div class="modal">
        <p v-if="!deleting">Are you sure you want to delete this BOM item?</p>
        <p v-else>Deleting...</p>
        <button v-if="!deleting" @click="confirmDelete">Delete</button>
        <button v-if="!deleting" id="cancelDeleteBtn" @click="cancelDelete">Cancel</button>
      </div>
    </div>
    <div v-if="showGroupNameConfirm" class="modal-overlay">
      <div class="modal">
        <p>
          Group Name must first be created in TALLY before creating here.<br>
          Please confirm if Group Name has been created in TALLY?
        </p>
        <button @click="confirmGroupNameCustom(true)">Yes</button>
        <button @click="confirmGroupNameCustom(false)" style="margin-left:8px">No</button>
      </div>
    </div>
    <div v-if="showUnitsConfirm" class="modal-overlay">
      <div class="modal">
        <p>
          Units must first be created in TALLY before creating here.<br>
          Please confirm if Units has been created in TALLY?
        </p>
        <button @click="confirmUnitsCustom(true)">Yes</button>
        <button @click="confirmUnitsCustom(false)" style="margin-left:8px">No</button>
      </div>
    </div>
    <!-- Add/Edit Modal -->
    <div v-if="showFormModal" class="modal-overlay" @click.self="closeFormModal" v-bind="saving ? { inert: '' } : {}">
      <div class="modal" style="max-width: 1300px; width: 100%; text-align: left;">
        <div v-if="saving" class="saving-bar">Saving...</div>
        <div v-if="formState === 'add'" class="copy-from-row" style="margin-bottom: 10px;" :class="{ 'disabled-area': saving }">
          <label style="font-weight:600; color:#283593; margin-right:8px;">Copy From:</label>
          <v-select
            v-model="copyFromItem"
            :options="bomList.map(bom => bom.Name)"
            placeholder="Select item to copy from..."
            :clearable="true"
            class="inline-select"
            style="min-width:220px; max-width:320px;"
          />
          <button type="button" @click="copyFromSelected" :disabled="!copyFromItem" style="margin-left:8px;">
            Copy From
          </button>
        </div>
        <!-- Add/Edit Form -->
         <div style="display: flex; gap: 5px; align-items: flex-start;" :class="{ 'disabled-area': saving }">
          <form class="bom-form" style="min-width: 350px; max-width: 350px; margin: 0 auto;" @submit.prevent="onSubmit">
            <div style="font-weight: bold; color: #000; margin-bottom: 10px;">
              Form State: <span>{{ formState === 'edit' ? 'Edit' : 'Add' }}</span>
            </div>
            <div class="form-row"><!-- Name -->
              <label>Name:</label>
              <input v-model="form.Name" required :readonly="formState === 'edit'" :class="{ 'disabled-input': formState === 'edit' }" />
              <span v-if="isDuplicateName && formState === 'add'" style="color: red; margin-left: 8px;">
                Duplicate name not allowed!
              </span>
              <span v-if="!isDuplicateName && formState === 'edit' && form.Name" style="color: red; margin-left: 8px;">
                Item does not exist for editing!
              </span>
            </div>
            <div class="form-row"><!-- Part No -->
              <label>Part No.:</label>
              <input
                v-model="form['Part No.']"
                :readonly="!partNoEditable"
                required
              />
              <button
                v-if="form.Name"
                type="button"
                @click="partNoEditable = !partNoEditable"
                style="margin-left:8px"
              >
                {{ partNoEditable ? 'Lock' : 'Edit Part No.' }}
              </button>
              <button
                v-if="partNoEditable"
                type="button"
                @click="autoAssignPartNo"
                style="margin-left:8px"
              >
                Auto Assign
              </button>
              <span v-if="isDuplicatePartNo && form['Part No.']" style="color: red; margin-left: 8px;">
                Duplicate Part No. not allowed!
              </span>
            </div>
            <div class="form-row"><!-- Description -->
              <label>Description:</label>
              <input v-model="form.Description" />
            </div>
            <div class="form-row"><!-- Is Batch Wise -->
              <label>Is Batch Wise:</label>
              <select v-model="form['Is Batch Wise']" required>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="form-row"><!-- Purchase Tag -->
              <label>Purchase Tag:</label>
              <select v-model="form['Purchase Tag']" required>
                <option value="">Select Purchase Tag</option>
                <option value="Bin System">Bin System</option>
                <option value="Purchase Relevant">Purchase Relevant</option>
                <option value="Made From Component">Made From Component</option>
                <option value="FG">FG</option>
                <option value="Bought Out">Bought Out</option>
              </select>
            </div>
            <span v-if="suggestedGroupName && form['Group Name'] !== suggestedGroupName" style="color: #888; font-size: 13px;">
              Suggested Group Name: {{ suggestedGroupName }}
            </span>
            <div class="form-row"><!-- Group Name -->
              <label>Group Name:</label>
              <template v-if="!groupNameCustom">
                <select v-model="form['Group Name']" required>
                  <option value="">Select Group Name</option>
                  <option v-for="name in groupNames" :key="name" :value="name">{{ name }}</option>
                </select>
                <button type="button" @click="showGroupNameConfirm = true" style="margin-left:8px">Custom Entry</button>
              </template>
              <template v-else>
                <input v-model="form['Group Name']" required placeholder="Enter custom group name" />
                <button type="button" @click="groupNameCustom = false" style="margin-left:8px">Use Dropdown</button>
              </template>
            </div>
            <div class="form-row"><!-- Units -->
              <label>Units:</label>
              <template v-if="!unitsCustom">
                <select v-model="form.Units" required>
                  <option value="">Select Units</option>
                  <option v-for="unit in unitNames" :key="unit" :value="unit">{{ unit }}</option>
                </select>
                <button type="button" @click="showUnitsConfirm = true" style="margin-left:8px">Custom Entry</button>
              </template>
              <template v-else>
                <input v-model="form.Units" required placeholder="Enter custom units" />
                <button type="button" @click="unitsCustom = false" style="margin-left:8px">Use Dropdown</button>
              </template>
            </div>
            <div class="form-row"><!-- Reorder Level -->
              <label>Reorder Level:</label>
              <input v-model="form['Reorder Level']" type="number" min="0" step="1" placeholder="Reorder Level" />
            </div>
            <div style="display: flex; justify-content: flex-end; gap: 10px; margin-top: 18px;"><!-- Buttons -->
              <button type="submit">{{ formState === 'edit' ? 'Update' : 'Add' }} Item</button>
              <button type="button" v-if="formState === 'add'" @click="resetForm" style="margin-left:8px">Reset</button>
            </div>
          </form>
          <!-- Components Section -->
          <div class="components-section" style="min-width: 875px; max-width: 875px;">
            <label style="font-weight:600; color:#283593; margin-bottom:8px; display:block;">Components:</label>
            <div v-if="form.Components.length === 0" style="color:#888; font-size:0.9em; margin-bottom:8px;">
              No components added. Click "Add Component" to add BOM for manufacture of 1 unit of {{ form['Name'] }}.
            </div>
            <div v-for="(comp, idx) in form.Components" :key="idx" class="component-row">
              <v-select v-model="comp['Item Name']"
                :options="itemNames"
                placeholder="Type to search..."
                :clearable="true"
                class="inline-select"
                required
              />
              <input v-model="comp['Quantity']" type="number" placeholder="Quantity" required />
              <select v-model="comp['Godown']" required>
                <option value="Assembly">Assembly</option>
                <option value="Store">Store</option>
              </select>
              <button type="button" @click="removeComponent(idx)" v-if="form.Components.length > 1">Remove</button>
              <button type="button" @click="removeComponent(idx)" v-else>Remove</button>
            </div>
            <button type="button" @click="addComponent" style="margin-top:8px;">Add Component</button>
          </div>
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import vSelect from "vue3-select";
import "vue3-select/dist/vue3-select.css";
import { watch } from 'vue';

const bomList = ref([]);
const backendUrl = process.env.VUE_APP_BACKEND_URL;
const apiUrl = backendUrl ? `${backendUrl}/api/bom` : 'http://localhost:3000/api/bom';
const itemNames = computed(() => bomList.value.map(bom => bom.Name).filter(Boolean));
const showDeleteModal = ref(false);
const deleteId = ref(null);
const deleting = ref(false);
const partNoEditable = ref(false);
const copyFromItem = ref(null);
const isDuplicateName = computed(() =>
  bomList.value.some(
    bom =>
      normalizeName(bom.Name) === normalizeName(form.value.Name)
  )
);
const filterName = ref('');
const filteredBomList = computed(() =>
  bomList.value.filter(bom =>
    (!filterName.value || (bom.Name && normalizeName(bom.Name).includes(normalizeName(filterName.value)))) &&
    (!filterPartNo.value || (bom['Part No.'] && bom['Part No.'].toLowerCase().includes(filterPartNo.value.toLowerCase()))) &&
    (!filterGroupName.value || bom['Group Name'] === filterGroupName.value) &&
    (!filterPurchaseTag.value || bom['Purchase Tag'] === filterPurchaseTag.value) &&
    (!filterReorderLevel.value || String(bom['Reorder Level']) === String(filterReorderLevel.value)) &&
    (!filterComponentName.value ||
      (bom.Components &&
        bom.Components.some(comp =>
          comp['Item Name'] &&
          comp['Item Name'].toLowerCase().includes(filterComponentName.value.toLowerCase())
        )
      )
    )
  )
);
const defaultComponent = () => ({
  'Item Name': '',
  'Quantity': '',
  'Godown': '',
  'Type of Item': 'Component',
});
const existingPartNos = computed(() =>
  bomList.value.map(bom => bom['Part No.']).filter(Boolean)
);
const isDuplicatePartNo = computed(() =>
  existingPartNos.value.includes(form.value['Part No.']) &&
  bomList.value.find(bom => bom.Name !== form.value.Name && bom['Part No.'] === form.value['Part No.'])
);
const form = ref({
  Name: '',
  'Part No.': '',
  Description: '',
  'Is Batch Wise': false,
  'Group Name': '',
  Units: '',
  'Reorder Level': '',
  'Purchase Tag': '',
  'Name of BOM': '',
  'Unit of manufacture': "",
  Components: [],
});
const groupNames = computed(() => {
  const tag = form.value['Purchase Tag'];
  if (!tag) return []; // No Purchase Tag selected, show empty list
  const names = bomList.value
    .filter(bom => bom['Purchase Tag'] === tag && bom['Group Name'])
    .map(bom => bom['Group Name']);
  return [...new Set(names)];
});
const suggestedGroupName = computed(() => {
  const name = form.value.Name;
  if (!name) return '';
  const normalized = normalizeName(name);
  const similar = bomList.value.filter(
    bom => normalizeName(bom.Name).includes(normalized) && bom['Group Name']
  );
  if (similar.length) {
    // Count occurrences of each group name
    const groupCount = {};
    similar.forEach(bom => {
      const group = bom['Group Name'];
      groupCount[group] = (groupCount[group] || 0) + 1;
    });
    // Find the most common group name
    return Object.entries(groupCount).sort((a, b) => b[1] - a[1])[0][0];
  }
  return '';
});
const groupNameCustom = ref(false);
const showGroupNameConfirm = ref(false);
const unitsCustom = ref(false);
const showUnitsConfirm = ref(false);
const unitNames = computed(() => {
  return [...new Set(bomList.value.map(bom => bom.Units).filter(Boolean))];
});
const filterPartNo = ref('');
const filterGroupName = ref('');
const filterPurchaseTag = ref('');
const filterReorderLevel = ref('');
const formState = ref('add'); // 'add' by default
const showFormModal = ref(false);
const filterComponentName = ref('');
const saving = ref(false);

function clearFilters() {
  filterName.value = '';
  filterPartNo.value = '';
  filterGroupName.value = '';
  filterPurchaseTag.value = '';
  filterReorderLevel.value = '';
}
const groupNameOptions = computed(() =>
  [...new Set(bomList.value.map(bom => bom['Group Name']).filter(Boolean))]
);
const purchaseTagOptions = computed(() =>
  [...new Set(bomList.value.map(bom => bom['Purchase Tag']).filter(Boolean))]
);

function addComponent() {
  form.value.Components.push(defaultComponent());
}
function removeComponent(idx) {
  form.value.Components.splice(idx, 1);
}
async function fetchBOM() {
  const res = await fetch(apiUrl);
  bomList.value = await res.json();
}
async function onSubmit() {
    const requiredFields = [
    'Name',
    'Part No.',
    'Is Batch Wise',
    'Purchase Tag',
    'Group Name',
    'Units'
  ];
  for (const field of requiredFields) {
    if (!form.value[field] || form.value[field] === '') {
      alert(`Field "${field}" is required.`);
      return;
    }
  }
  // Components required fields
  for (const [i, comp] of form.value.Components.entries()) {
    if (!comp['Item Name'] || !comp['Quantity'] || !comp['Godown']) {
      alert(`All component fields (Item Name, Quantity, Godown) are required for component #${i + 1}.`);
      return;
    }
  }
  if (isDuplicatePartNo.value) {
    alert('Duplicate Part No. not allowed!');
    return;
  }
  saving.value = true;
  // Check if this is an update or add
  try {
    if (formState.value === 'edit') {
      // Must exist in bomList
      const existing = bomList.value.find(bom => normalizeName(bom.Name) === normalizeName(form.value.Name));
      if (!existing) {
        alert('Item does not exist for editing!');
        return;
      }
      // Update
      await fetch(`${apiUrl}/${encodeURIComponent(normalizeName(form.value.Name))}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form.value),
      });
      showFormModal.value = false;
    } else {
      // Must NOT exist in bomList
      const existing = bomList.value.find(bom => normalizeName(bom.Name) === normalizeName(form.value.Name));
      if (existing) {
        alert('Item already exists! Use Edit instead.');
        return;
      }
      // Add
      await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form.value),
      });
    }
    resetForm();
    await fetchBOM();
  } finally {
    saving.value = false;
  }
}
function editItem(item) {
  // Deep copy and enforce 'Type of Item' for all components
  form.value = {
    ...item,
    Components: item.Components
      ? item.Components.map(c => ({ ...c, 'Type of Item': 'Component' }))
      : [defaultComponent()],
  };
  partNoEditable.value = false;
  formState.value = 'edit';
}
function resetForm() {
  form.value = {
    Name: '',
    'Part No.': '',
    Description: '',
    'Is Batch Wise': false,
    'Group Name': '',
    Units: '',
    'Reorder Level': '',
    'Purchase Tag': '',
    'Name of BOM': '',
    'Unit of manufacture': "",
    Components: [],
    groupNameCustom: false,
    partNoEditable: false,
    unitsCustom: false,
  };
  partNoEditable.value = false;
  formState.value = 'add';
}
function normalizeName(name) {
  return name
    ? name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase()
    : '';
}
function getPartNoPrefix(purchaseTag) {
  switch (purchaseTag) {
    case 'Bin System': return 'S';
    case 'Purchase Relevant': return 'C';
    case 'Made From Component': return 'V';
    case 'FG': return 'F';
    case 'Bought Out': return 'B';
    default: return '';
  }
}
function getNextPartNo(prefix) {
  // Find all Part Nos with the given prefix
  const numbers = bomList.value
    .map(bom => bom['Part No.'])
    .filter(pn => pn && pn.startsWith(prefix))
    .map(pn => {
      const match = pn.match(new RegExp(`^${prefix}(\\d+)$`));
      return match ? parseInt(match[1], 10) : 0;
    });
  const maxNum = numbers.length ? Math.max(...numbers) : 0;
  return `${prefix}${maxNum + 1}`;
}
function openDeleteModal(name) {
  deleteId.value = name;
  showDeleteModal.value = true;
  setTimeout(() => {
    const cancelBtn = document.getElementById('cancelDeleteBtn');
    if (cancelBtn) cancelBtn.focus();
  }, 0);
}
async function confirmDelete() {
  deleting.value = true;
  await fetch(`${apiUrl}/${encodeURIComponent(deleteId.value)}`, { method: 'DELETE' });
  await fetchBOM();
  showDeleteModal.value = false;
  deleteId.value = null;
  deleting.value = false;
}
function cancelDelete() {
  showDeleteModal.value = false;
  deleteId.value = null;
}
function autoAssignPartNo() {
  // Check if this BOM is a variant (Components exactly one object)
  if (form.value.Components && form.value.Components.length === 1) {
    const childName = form.value.Components[0]['Item Name'];
    const child = bomList.value.find(bom => bom.Name === childName);
    if (child && child['Part No.']) {
      // Find all existing Part Nos that match the pattern: childPartNo + [A-Z]
      const basePartNo = child['Part No.'];
      const usedLetters = bomList.value
        .map(bom => {
          const match = (bom['Part No.'] || '').match(new RegExp(`^${basePartNo}([A-Z])$`));
          return match ? match[1] : null;
        })
        .filter(Boolean);

      // Find the first unused letter from A-Z
      let nextLetter = 'A';
      for (let i = 0; i < 26; i++) {
        const letter = String.fromCharCode(65 + i); // 65 is 'A'
        if (!usedLetters.includes(letter)) {
          nextLetter = letter;
          break;
        }
      }
      form.value['Part No.'] = basePartNo + nextLetter;
      return;
    }
  }
  // Fallback to your existing logic
  const prefix = getPartNoPrefix(form.value['Purchase Tag']);
  if (prefix) {
    form.value['Part No.'] = getNextPartNo(prefix);
  }
}
function confirmGroupNameCustom(confirmed) {
  if (confirmed) {
    groupNameCustom.value = true;
  }
  showGroupNameConfirm.value = false;
}
function confirmUnitsCustom(confirmed) {
  if (confirmed) {
    unitsCustom.value = true;
  }
  showUnitsConfirm.value = false;
}
function copyFromSelected() {
  const item = bomList.value.find(bom => bom.Name === copyFromItem.value);
  if (!item) return;
  // Deep copy, clear id and part no, reset Components' ids if any
  form.value = {
    ...item,
    Name: '',
    'Part No.': '',
    id: null,
    Components: item.Components
      ? item.Components.map(c => ({ ...c, 'Type of Item': 'Component' }))
      : [defaultComponent()],
  };
  partNoEditable.value = false;
}
function openAddModal() {
  resetForm();
  showFormModal.value = true;
}
function openEditModal(item) {
  editItem(item);
  showFormModal.value = true;
}
function closeFormModal() {
  showFormModal.value = false;
}

watch(
  () => form.value['Purchase Tag'],
  () => {
    // Only auto-assign if form state is Add
    if (formState.value === 'add') {
      autoAssignPartNo();
    }
  }
);

// Watch Components array for changes
watch(
  () => form.value.Components.map(comp => comp['Item Name']),
  () => {
    // Only auto-assign if form state is add
    if (formState.value === 'add') {
      autoAssignPartNo();
    }
  },
  { deep: true }
);

watch(
  () => form.value.Components.length,
  (newLen) => {
    if (newLen === 0) {
      form.value['Name of BOM'] = '';
      form.value['Unit of manufacture'] = '';
    } else if (newLen === 1 && !form.value['Name of BOM'] && !form.value['Unit of manufacture']) {
      form.value['Name of BOM'] = 'Manufacturing (from Excel)';
      form.value['Unit of manufacture'] = 1;
    }
  }
);

onMounted(fetchBOM);
</script>

<style scoped>
body {
  font-family: 'Segoe UI', Arial, sans-serif;
  background: #f4f7fa;
}

/* Layout */
.bom-main-content {
  display: flex;
  align-items: flex-start;
  width: 100vw;
  min-height: 100vh;
  background: #f4f7fa;
}

/* Copy From Row */
.copy-from-row {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 18px 32px 8px 32px;
  background: #f4f7fa;
  border-bottom: 1px solid #e3e6ea;
  box-sizing: border-box;
  z-index: 10;
  margin-bottom: 0;
}
.copy-from-row .inline-select {
  min-width: 340px;
  max-width: 480px;
  flex: 2 1 0;
}

/* Form */
.bom-form {
  width: 256px;
  min-width: 208px;
  max-width: 272px;
  background: #fff;
  border-radius: 11px 0 0 11px;
  box-shadow: 0 3.2px 19.2px rgba(26,35,126,0.08);
  padding: 26px 18px 19px 18px;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 11px;
  border-right: 1.2px solid #e3e6ea;
  position: sticky;
  top: 0;
  height: 80vh;
  overflow-y: auto;
  font-size: 0.8rem;
}
.form-row {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.form-row label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #283593;
  margin-bottom: 2px;
  letter-spacing: 0.08px;
}
input,
select,
.inline-select {
  padding: 6px 8px;
  border: 1px solid #c5cae9;
  border-radius: 4px;
  font-size: 0.8rem;
  background: #f8fafc;
  color: #1a237e;
  margin-right: 6px;
  transition: border 0.2s, box-shadow 0.2s;
}
input:focus,
select:focus,
.inline-select:focus-within {
  border-color: #536dfe;
  box-shadow: 0 0 0 1.6px #e3eaff;
  outline: none;
}
button {
  background: linear-gradient(90deg, #536dfe 0%, #1e88e5 100%);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  margin-right: 6px;
  margin-top: 3px;
  transition: background 0.18s, box-shadow 0.18s;
  box-shadow: 0 2px 8px rgba(83,109,254,0.07);
}
button[type="button"]:hover,
button[type="submit"]:hover {
  background: linear-gradient(90deg, #3949ab 0%, #1565c0 100%);
}
button[disabled] {
  background: #b0bec5;
  cursor: not-allowed;
}
button#cancelDeleteBtn {
  background: #e3e6ea;
  color: #222;
}
button#cancelDeleteBtn:hover {
  background: #b0bec5;
}
span[style*="color: red"] {
  font-size: 0.776rem;
  margin-left: 0;
  margin-top: 2px;
}
span[style*="color: #888"] {
  margin-left: 0;
  margin-bottom: 3px;
  color: #607d8b !important;
  font-size: 0.776rem;
}

/* Table Area */
.bom-table-area {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 26px 26px 26px 0;
  background: #f4f7fa;
  height: 100vh;
  box-sizing: border-box;
}

/* Components Section */
.components-section {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(26,35,126,0.06);
  padding: 14px 18px 10px 18px;
  margin-bottom: 18px;
  min-width: 420px;
  max-width: 900px;
}
.component-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.component-row .inline-select {
  min-width: 200px;
  max-width: 340px;
  flex: 3 1 0;
}
.component-row input[type="number"] {
  min-width: 80px;
  max-width: 100px;
  flex: 1 1 0;
}
.component-row select {
  min-width: 100px;
  max-width: 120px;
  flex: 1 1 0;
}
.component-row input[disabled] {
  min-width: 90px;
  max-width: 120px;
  flex: 1 1 0;
}
.component-row button {
  margin-left: 8px;
  padding: 4px 10px;
  font-size: 0.8rem;
}

/* Filters */
.bom-filter-row {
  display: flex;
  gap: 10px;
  justify-content: flex-start;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.bom-filter-input, .bom-filter-select {
  min-width: 120px;
  max-width: 180px;
  padding: 6px 8px;
  border: 1px solid #c5cae9;
  border-radius: 4px;
  font-size: 0.8rem;
  background: #f8fafc;
  color: #1a237e;
}
.bom-filter-input:focus, .bom-filter-select:focus {
  border-color: #536dfe;
  box-shadow: 0 0 0 1.6px #e3eaff;
  outline: none;
}

/* Table Scroll */
.table-scroll {
  flex: 1 1 0;
  overflow-y: auto;
  min-height: 0;
  overflow-x: auto;
  background: #f4f7fa;
}
.table-scroll table {
  width: 100%;
  min-width: 720px;
  background: #fff;
  border-radius: 0 11px 11px 0;
  overflow: hidden;
  box-shadow: 0 3.2px 19.2px rgba(26,35,126,0.08);
  border-collapse: separate;
  border-spacing: 0;
}
th, td {
  border-bottom: 0.8px solid #e3e6ea;
  padding: 10px 12px;
  text-align: left;
  font-size: 0.832rem;
}
th {
  background: #e8eaf6;
  font-weight: 700;
  color: #1a237e;
  letter-spacing: 0.4px;
  position: sticky;
  top: 0;
  z-index: 2;
}
tr:last-child td {
  border-bottom: none;
}
tr:hover td {
  background: #f1f8ff;
  transition: background 0.15s;
}
ul {
  margin: 0;
  padding-left: 14px;
  font-size: 0.8rem;
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(26,35,126,0.13);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal {
  background: #fff;
  padding: 29px 22px;
  border-radius: 10px;
  box-shadow: 0 3.2px 19.2px rgba(26,35,126,0.18);
  min-width: 272px;
  text-align: center;
  font-size: 0.8rem;
}

/* Responsive */
@media (max-width: 1100px) {
  .bom-main-content {
    flex-direction: column;
  }
  .bom-form {
    width: 80vw;
    max-width: 80vw;
    border-radius: 0;
    border-right: none;
    border-bottom: 1.2px solid #e3e6ea;
    height: auto;
    position: static;
    box-shadow: none;
    padding: 14px 5px 10px 5px;
  }
  .bom-table-area {
    padding: 14px 0 0 0;
    height: auto;
  }
  .table-scroll table {
    border-radius: 0 0 11px 11px;
  }
}
@media (max-width: 700px) {
  .components-section {
    min-width: 0;
    max-width: 100vw;
    padding: 8px 4px 6px 4px;
  }
  .bom-table-area {
    padding: 6px 0 0 0;
  }
  .table-scroll table {
    font-size: 0.776rem;
  }
}
.mini-components-table {
  width: 100%;
  border-collapse: collapse;
  background: #f8fafc;
  font-size: 0.75em;
  margin: 0;
  table-layout: fixed;
}
.mini-components-table th:nth-child(1),
.mini-components-table td:nth-child(1) {
  width: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mini-components-table th:nth-child(2),
.mini-components-table td:nth-child(2) {
  width: 1px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mini-components-table th:nth-child(3),
.mini-components-table td:nth-child(3) {
  width: 10px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.clear-filters-btn {
  background: #e3e6ea;
  color: #283593;
  border: none;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  margin-left: 10px;
  transition: background 0.18s, box-shadow 0.18s;
}
.clear-filters-btn:hover {
  background: #b0bec5;
}
.disabled-input {
  background: #f1f1f1 !important;
  color: #888 !important;
  cursor: not-allowed !important;
  border-color: #e0e0e0 !important;
}
.saving-bar {
  background: #283593;
  color: #fff;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  margin-bottom: 10px;
  font-size: 0.8rem;
  animation: pulse 1s infinite ease-in-out;
}
@keyframes pulse {
  0%,100% { opacity: 0.85; }
  50% { opacity: 0.45; }
}
.disabled-area {
  pointer-events: none;
  opacity: 0.55;
  filter: grayscale(10%);
}
</style>